module.exports = __webpack_public_path__ + "static/media/ship_yellow.5d8a2cc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_yellow.png
// module id = 203
// module chunks = 0